// Lib
import React from 'react';
import classNames from 'classnames';
import { Button as RomaButton } from '@milanote/roma';

// Hooks
import { useTranslator } from '../../../../../components/i18n/useTranslator';

type CancelDiscardButtonProps = {
    // Discard replaces Cancel once the editor has changes to throw away.
    showDiscard: boolean;
} & Omit<React.ComponentProps<typeof RomaButton>, 'children'>;

/**
 * Editor-toolbar secondary action that reads Cancel until the editor has changes, then Discard.
 *
 * Both labels are always laid out (the inactive one invisibly) so the button — and the centred toolbar
 * pill around it — keeps a single width instead of resizing whenever the label swaps.
 */
const CancelDiscardButton: React.FC<CancelDiscardButtonProps> = ({ showDiscard, ...buttonProps }) => {
    const translate = useTranslator('popup', 'drawing');

    return (
        <RomaButton color="secondary" {...buttonProps}>
            <span className="grid justify-items-center">
                <span
                    aria-hidden={showDiscard}
                    className={classNames('col-start-1 row-start-1', { invisible: showDiscard })}
                >
                    {translate('cancel')}
                </span>
                <span
                    aria-hidden={!showDiscard}
                    className={classNames('col-start-1 row-start-1', { invisible: !showDiscard })}
                >
                    {translate('discard')}
                </span>
            </span>
        </RomaButton>
    );
};

export default CancelDiscardButton;
